<template>
    <div class="page-support">
        <!--content-->
        <SupportList />
        <div class="container">
            <div class="single">
                <div class=" single-grid">

                    <div class="tit">前言</div>

                    <p>非常感激每一位打赏的朋友！我们会努力收集更多好玩的游戏。赞助所得将用于服务器以及域名费用。</p>
                    <p>温馨提示：赞助请务必备注一下，方便我们把您记录在这个列表里~</p>
                    <p></p>

                    <div class="tit">其它</div>
                    <div class="btn-group">
                        <a href="//qm.qq.com/cgi-bin/qm/qr?k=AnZJbnsU8BsmQGGEWs4rXd-JuSJI-j9c&jump_from=webapi" title="点击加入 - Git游戏放置交流群:793344327" class="cd-read-more  hvr-wobble-top btn-info" target="_blank">QQ交流群</a>
                        <a href="javascript:void(0)" title="您的支持，是我最大的动力！" class="cd-read-more  hvr-wobble-top btn-info btn-dashang" @click="open()">我要赞助</a>

                    </div>
                    <div class="tit">赞助支持者列表</div>
                    <table class="my-table">
                        <tr>
                            <th>日期</th>
                            <th>金额(元)</th>
                            <th>赞助方式</th>
                            <th>赞助支持者</th>
                        </tr>
                        <tr v-for="s in gameList">
                            <td>{{s.date}}</td>
                            <td>{{s.amount}}</td>
                            <td>{{s.payment}}</td>
                            <td>{{s.name}}</td>
                        </tr>
                        <tr>
                            <td colspan="2">总计</td>
                            <td colspan="2">{{total.toFixed(2)}} 元</td>
                        </tr>

                    </table>

                </div>

            </div>
        </div>

        <!--//content-->
        <!--images-->
        <div class="container">
            <div class="games">
                <!--					<div class="tit">游戏图鉴</div>-->
                <section style="display: none">
                </section>

            </div>
        </div>
        <!--//images-->
    </div>
</template>
<script>
import SupportList from '@/components/Support.vue'
export default {
  name: 'Support',
  components: {
    SupportList
  },
  data() {
    return {
      gameList: [],
      total: 0
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/support.json' + '?' + timeStamp).then(game => {
        for (var i = 0; i < game.data.length; i++) {
          this.gameList = game.data
          this.total += game.data[i].amount
        }
      })
    },
    open() {
      $('.hide_box').fadeIn()
      $('.shang_box').fadeIn()
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Support.vue